import React from 'react';

import './styles.scss';
import {Column, Row} from '../../../components/layout';
import Header1 from '../../../components/headers/header1';
import * as fonts from '../../../util/fonts';
import colors from '../../../util/colors';
import AppButton from '../../../components/app-button';
import {useHistory} from 'react-router-dom';
import RegisterHeader from '../../../components/headers/register-header';
import {strings} from '../../../util/strings';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {createGUID} from '../../../util/utility';

interface ExistingUserProps {
  labels: typeof strings.pt.register;
}

function ExistingUser({labels}: ExistingUserProps) {
  const history = useHistory();

  return (
    <Column className="register-main-column">
      <RegisterHeader />
      <Column className="register-container">
        <Row className="register-header-row">
          <Header1 style={{...fonts.XL, ...fonts.Bold, color: colors.black}}>
            {labels?.errorUser_pageTitle}
          </Header1>
        </Row>
        <Column className="register-existing-user-text" style={{...fonts.ML}}>
          <Row>{labels?.errorUser_text1}</Row>
          <Row></Row>
          <a href={'/recuperar-palavra-passe'}>
            <AppButton
              type="link"
              variant="inverted"
              className="register-adv-plus-recover-password"
              style={{
                backgroundColor: 'transparent',
              }}>
              {labels?.errorUser_text2}
            </AppButton>
          </a>
          <AppButton
            label="Continuar"
            onClick={() => history.push('/')}
            className="register-existing-user-login-button">
            {labels?.registerComplete_buttonText}
          </AppButton>
        </Column>
      </Column>
    </Column>
  );
}

const mapStateToProps = ({strings}: any) => ({
  labels: strings.value.pt.register,
});
export default compose(connect(mapStateToProps)(ExistingUser));
